import { getMsalInstance } from './msalInstance';

const AUTH_REDIRECT_KEY = 'ssds2_auth_redirect_in_progress';
const AUTH_REDIRECT_TIMEOUT = 30000; // 30 segundos

/**
 * Verifica se estamos em um loop de redirecionamento
 */
function isRedirectLoopDetected(): boolean {
  const redirectData = sessionStorage.getItem(AUTH_REDIRECT_KEY);
  if (!redirectData) return false;

  try {
    const { timestamp } = JSON.parse(redirectData);
    const elapsed = Date.now() - timestamp;

    // Se o redirect foi iniciado ha menos de 30 segundos, pode ser um loop
    if (elapsed < AUTH_REDIRECT_TIMEOUT) {
      return true;
    }

    // Redirect expirou, limpa o marcador
    sessionStorage.removeItem(AUTH_REDIRECT_KEY);
    return false;
  } catch {
    sessionStorage.removeItem(AUTH_REDIRECT_KEY);
    return false;
  }
}

/**
 * Marca que estamos iniciando um redirecionamento de autenticacao
 */
function markRedirectStarted(): void {
  sessionStorage.setItem(
    AUTH_REDIRECT_KEY,
    JSON.stringify({
      timestamp: Date.now(),
    })
  );
}

/**
 * Limpa o marcador de redirecionamento (chamar apos login bem-sucedido)
 */
export function clearAuthRedirectMarker(): void {
  sessionStorage.removeItem(AUTH_REDIRECT_KEY);
}

/**
 * Trata erro de autenticacao 401 limpando cache e redirecionando para login
 */
export async function handleAuthenticationError(): Promise<void> {
  console.warn('[Auth] Tratando erro de autenticacao 401');

  // Previne loops infinitos de redirecionamento
  if (isRedirectLoopDetected()) {
    console.error('[Auth] Loop de redirecionamento detectado, limpando estado de auth');
    const msalInstance = getMsalInstance();
    await msalInstance.clearCache();
    sessionStorage.removeItem(AUTH_REDIRECT_KEY);
    // Redireciona para login sem MSAL
    window.location.href = '/login';
    return;
  }

  try {
    const msalInstance = getMsalInstance();

    // Limpa todos os tokens em cache - estao expirados/invalidos
    await msalInstance.clearCache();
    console.log('[Auth] Cache MSAL limpo');

    // Marca redirecionamento como em progresso
    markRedirectStarted();

    // Redireciona para pagina de login
    window.location.href = '/login';
  } catch (error) {
    console.error('[Auth] Erro durante tratamento de erro de autenticacao:', error);
    // Fallback: apenas redireciona para login
    window.location.href = '/login';
  }
}

/**
 * Verifica se um erro e um erro de autenticacao 401
 */
export function isAuthenticationError(error: unknown): boolean {
  if (error && typeof error === 'object' && 'response' in error) {
    const axiosError = error as { response?: { status?: number } };
    return axiosError.response?.status === 401;
  }
  return false;
}
